import React from 'react';
export default function TransferIcons({image}) {
    return <img src={image} alt="" style={{height: '33px'}}/>
}